

























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component} from "vue-property-decorator";
import {CountryStore} from "@/modules/regionsv2/country/store";
import {FormModel} from "ant-design-vue";

const form = {
    code: undefined,
    name: undefined
}
@Component({
    name: "CountryForm"
})
export default class extends mixins(CommonMixin) {
    form = { ...form };
    rules = {
        code: [{ required: true, message: "Nhập mã nước" }],
        name: [{ required: true, message: "Nhập tên nước" }],
    }
    submit() {
        (this.$refs.form as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                await CountryStore.createCountryV2(this.form);
                this.resetForm();
                this.$message.success("Tạo nước thành công");
            } catch (e) {
                this.$message.success("Tạo nước thất bại");
            }
        })
    }
    resetForm() {
        this.form = { ...form };
    }
}
